import { withConfig } from "@/utils/withConfig";
import { PersonalDetails } from "./PersonalDetails";
import type { PersonalDetailsProps } from "./PersonalDetailsProps";

export * from "./PersonalDetails";
export * from "./PersonalDetailsProps";

export const PersonalDetailsWithConfig = withConfig<PersonalDetailsProps>(
  PersonalDetails,
  "personal_details",
);
